export class School {
  id: number;
  clientId: number;
  cityWeatherId: number;
  name: string;
  codeSchool: string;
  nameForSms: string;
  lat: number;
  lng: number;
  creationDate: string;
  endShcoolYear: string;
  respAppName: string;
  respAppTel: string;
  subscriptionSchoolYear: string;
  subscriptionOn: number;
  zonesOfService: any[];
  Passengers: any[];
  // schoolAgendas
  // buses
  
  constructor() { 
    this.respAppTel = '06';
  }
}



// WEBPACK FOOTER //
// ./src/app/models/school.ts